import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const IDENTS_URL = `${domain}/api/idents`;

export const identsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllIdents: builder.query({
      query: () => ({
        url: `${IDENTS_URL}`,
      }),
      providesTags: ["Idents"],
    }),
    updateIdent: builder.mutation({
      query: (identData) => ({
        url: `${IDENTS_URL}/${identData.id}`,
        method: "PUT",
        body: identData,
      }),
      invalidatesTags: ["Idents"],
    }),
    addIdent: builder.mutation({
      query: (identData) => ({
        url: `${IDENTS_URL}`,
        method: "POST",
        body: identData,
      }),
      invalidatesTags: [
        "Idents",
      ],
    }),
  }),
});

export const {
  useGetAllIdentsQuery, useUpdateIdentMutation, useAddIdentMutation
} = identsApiSlice;
